'use client';

import { useEffect } from 'react';
import { useExposureEvent } from '@alltrails/experiments';

export default function ModuleXpExposureWrapper({ isBot }: { isBot: boolean }) {
  const sendExposure = useExposureEvent('web-growth-rm-homepage-module-removal-v2');

  useEffect(() => {
    if (!isBot) {
      sendExposure();
    }
  }, [sendExposure, isBot]);

  return null;
}
